import { render } from "./dzrecord.vue?vue&type=template&id=0d43b1d3&scoped=true&ts=true"
import script from "./dzrecord.vue?vue&type=script&lang=ts"
export * from "./dzrecord.vue?vue&type=script&lang=ts"

import "./dzrecord.vue?vue&type=style&index=0&id=0d43b1d3&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d43b1d3"]])

export default __exports__